module.exports = __webpack_public_path__ + "img/full6-min.26c153e9.png";